import React, {useState} from "react";

const withHover = (WrappedComponent)=>{
    return props => {
        const {children, parentClassNames = '', handleMouseOver, ...rest} = props,
            [hover,setHover] = useState(false);

        const handleHover = (value)=>{
            setHover(value);
        }

        return (
            <div className={parentClassNames} onMouseOver={()=>{handleHover(true)}} onMouseOut={()=>{handleHover(false)}}>
                <WrappedComponent hover={hover} {...rest}>{children}</WrappedComponent>
            </div>
        );
    }
}

export default withHover;